import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {},
  reducers: {
    logout: () => ({}), // Empty object resets the auth slice
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
